module.exports = "https://web-assets.ifttt.com/packs/media/home/clock-0fd0a292.svg";